/*
 * GND custom: Mobile auto-rotate secondary product image
 * Added 2026-04-22 — safe to relocate during Borders theme upgrade.
 * Paired with: assets/gnd-card-rotate.css
 * Script tag: layout/theme.liquid (just before </body>)
 */
(function () {
  'use strict';

  var scriptEl = document.currentScript;

  if (!('IntersectionObserver' in window)) return;
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (scriptEl && scriptEl.dataset.css) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = scriptEl.dataset.css;
    document.head.appendChild(link);
  }

  var INITIAL_DELAY = 1200;
  var INITIAL_DELAY_FAST = 300;
  var HOLD_DURATION = 2500;
  var FADE_DURATION = 800;
  var STAGGER_STEP = 1400;
  var STAGGER_STEP_FAST = 400;
  var ROW_STAGGER_STEP = 2000;
  var ROW_STAGGER_STEP_FAST = 0;
  var ROW_STAGGER_MAX = 4;
  var VELOCITY_NORMAL = 500;
  var VELOCITY_FAST = 1500;

  var scrollVelocity = 0;
  var lastScrollY = window.scrollY;
  var lastScrollTime = performance.now();
  var scrollResetTimer = null;

  function onScroll() {
    var now = performance.now();
    var dt = now - lastScrollTime;
    if (dt > 0) {
      var dy = Math.abs(window.scrollY - lastScrollY);
      scrollVelocity = (dy / dt) * 1000;
    }
    lastScrollY = window.scrollY;
    lastScrollTime = now;
    clearTimeout(scrollResetTimer);
    scrollResetTimer = setTimeout(function () { scrollVelocity = 0; }, 300);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function getDelaysForVelocity(v) {
    var norm = clamp((v - VELOCITY_NORMAL) / (VELOCITY_FAST - VELOCITY_NORMAL), 0, 1);
    return {
      initial: lerp(INITIAL_DELAY, INITIAL_DELAY_FAST, norm),
      col: lerp(STAGGER_STEP, STAGGER_STEP_FAST, norm),
      row: lerp(ROW_STAGGER_STEP, ROW_STAGGER_STEP_FAST, norm),
    };
  }

  var observer = new IntersectionObserver(onIntersect, { threshold: [0.5, 1.0] });
  var gridMutationObserver = null;

  function getGridCols() {
    var grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return 2;
    if (grid.classList.contains('grid-palm-3')) return 3;
    if (grid.classList.contains('grid-palm-2')) return 2;
    return 1;
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio >= 0.5) {
        startRotation(entry.target);
      } else {
        stopRotation(entry.target);
      }
    });
  }

  function startRotation(card) {
    if (card.dataset.gndScheduled === '1') return;
    card.dataset.gndScheduled = '1';

    var timers = [];
    card._gndTimers = timers;

    var rect = card.getBoundingClientRect();
    var delays = getDelaysForVelocity(scrollVelocity);

    var colStagger = 0;
    if (getGridCols() === 2) {
      var centerX = rect.left + (rect.width / 2);
      if (centerX > window.innerWidth / 2) colStagger = delays.col;
    }

    var cardHeight = rect.height || 1;
    var rowIndex = Math.min(ROW_STAGGER_MAX, Math.max(0, Math.floor(rect.top / cardHeight)));
    var rowStagger = rowIndex * delays.row;

    timers.push(setTimeout(function () {
      card.classList.add('gnd-rotate-active');
      timers.push(setTimeout(function () {
        card.classList.remove('gnd-rotate-active');
        timers.push(setTimeout(function () {
          card.dataset.gndScheduled = '0';
        }, FADE_DURATION));
      }, HOLD_DURATION));
    }, delays.initial + colStagger + rowStagger));
  }

  function stopRotation(card) {
    if (card._gndTimers) {
      card._gndTimers.forEach(clearTimeout);
      card._gndTimers = [];
    }
    card.classList.remove('gnd-rotate-active');
    card.dataset.gndScheduled = '0';
  }

  function stopAllRotations() {
    document.querySelectorAll('.product-item').forEach(stopRotation);
  }

  function observeCards() {
    if (getGridCols() >= 3) {
      observer.disconnect();
      stopAllRotations();
      return;
    }

    document.querySelectorAll('.product-item').forEach(function (card) {
      if (!card.querySelector('.product-item__image-secondary')) return;
      if (card.classList.contains('product-item--sold-out')) return;
      observer.observe(card);
    });
  }

  function watchGridChanges() {
    var grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return;
    if (gridMutationObserver) gridMutationObserver.disconnect();
    gridMutationObserver = new MutationObserver(observeCards);
    gridMutationObserver.observe(grid, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    observeCards();
    watchGridChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
